import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

/**
 * A media link has to be a web address and nothing else.
 *
 * The generic write path behind these fields stores whatever it is handed, and
 * these values are read back on a page that turns them into a frame and a link.
 * A `javascript:` value pasted here would be stored as happily as an https one,
 * so the refusal belongs at the point where the broker can still see what they
 * typed and fix it.
 *
 * Parsed rather than matched against a pattern: the URL parser is the same one
 * a browser uses to decide what a link means, and a pattern that merely looks
 * for "http" at the front is fooled by whitespace and by control characters.
 */
export const validationErrorsForMediaUrl = (value?: string | null) => {
  const result: string[] = [];
  const trimmed = (value || "").trim();

  if (!trimmed) {
    return result;
  }

  let parsed: URL | undefined;

  try {
    parsed = new URL(trimmed);
  } catch {
    parsed = undefined;
  }

  if (
    !parsed ||
    (parsed.protocol !== "http:" && parsed.protocol !== "https:")
  ) {
    result.push(getLocalizedText("property.extra.media.error.url"));
  }

  return result;
};
